// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fraxtalTestnet as _fraxtalTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fraxtalTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2522
 * Chain Name: Fraxtal Testnet
 * Default Block Explorer: https://holesky.fraxscan.com
 * Default RPC URL: https://rpc.testnet.frax.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fraxtalTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fraxtalTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fraxtalTestnet = createCommon({
	..._fraxtalTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
